import { render, staticRenderFns } from "./select-geo-area.vue?vue&type=template&id=3fc2a439&lang=pug&"
import script from "./select-geo-area.vue?vue&type=script&lang=ts&"
export * from "./select-geo-area.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports